// Google Analytics Configuration
// Replace G-XXXXXXXXXX with your actual Google Analytics Measurement ID
// You can find it in Google Analytics: Admin → Data Streams → Web → Measurement ID

export const GA_MEASUREMENT_ID = 'G-6LGQHRM29Q';

// Helper function to track page views
export const trackPageView = (path, title) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: path,
      page_title: title
    });
  }
};

// Helper function to track custom events
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag && GA_MEASUREMENT_ID !== 'G-XXXXXXXXXX') {
    window.gtag('event', eventName, eventParams);
  }
};
